export default "__VITE_ASSET__UaZG4vwM__"